module.exports = __webpack_public_path__ + "img/1488693411.434828ab.jpg";